import React from 'react'
import { intl } from 'lang/intl'

import { initials } from '../../sharedLegacy/components/DefaultAvatarComponent/DefaultAvatarComponent'
import { pickRandomColor } from '../../sharedLegacy/utils'

import Chyron, { ChyronSize } from './chyron'

import './speakers-overview-chyron.scss'

interface SpeakersOverviewChyronProps {
  speakers: readonly {
    name: string
    title?: string
    avatarUrl?: string
    company?: string
  }[]
}

const SpeakersOverviewChyron = ({ speakers }: SpeakersOverviewChyronProps) => {
  return (
    <Chyron
      size={speakers.length > 3 ? ChyronSize.Medium : ChyronSize.Small}
      kickerPosition="top"
      kicker={intl.formatMessage({ defaultMessage: 'Speakers' })}
    >
      <div className="speakers-chyron">
        {speakers.map(({ name, title, avatarUrl, company }) => (
          <div className="speaker" key={name}>
            {avatarUrl && (
              <div className="picture">
                <img src={avatarUrl} alt="" />
              </div>
            )}
            {!avatarUrl && (
              <div
                className="initials"
                style={{
                  backgroundColor: pickRandomColor(name),
                }}
              >
                <div>{initials(name)}</div>
              </div>
            )}
            <div className="speaker-info">
              <div className="name">{name}</div>
              {(title || company) && (
                <div className="title">
                  {[title, company].filter((v) => !!v).join(' at ')}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </Chyron>
  )
}

export default SpeakersOverviewChyron
